import React from 'react';
import { Crown, Phone, Clock, Calendar, Shield, Star, CheckCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Button } from './ui/button';

const VipSubscription = () => {
  return (
    <section className="py-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-10 right-10 w-72 h-72 bg-yellow-400/10 rounded-full blur-3xl" />
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-amber-400/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-5xl mx-auto px-4 relative">
        <div className="bg-gradient-to-br from-amber-500/20 via-yellow-500/10 to-amber-600/20 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-amber-400/30 shadow-2xl">
          
          {/* Badge VIP */}
          <div className="flex justify-center mb-6">
            <div className="bg-gradient-to-r from-amber-400 to-yellow-500 text-slate-900 px-6 py-2 rounded-full font-bold text-sm flex items-center gap-2 shadow-lg">
              <Crown size={18} />
              OFFRE EXCLUSIVE
              <Crown size={18} />
            </div>
          </div>

          {/* Titre */}
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
              Abonnement Client <span className="text-amber-400">VIP</span>
            </h2>
            <p className="text-slate-300 text-lg max-w-2xl mx-auto">
              Votre tranquillité d'esprit pour seulement quelques euros par mois
            </p>
          </div>

          {/* Prix */}
          <div className="flex justify-center mb-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 text-center border border-amber-400/20">
              <p className="text-amber-400 font-semibold mb-1">À partir de</p>
              <div className="flex items-baseline justify-center gap-1">
                <span className="text-5xl md:text-6xl font-bold text-white">9,90</span>
                <span className="text-2xl text-amber-400 font-bold">€</span>
                <span className="text-slate-400 text-lg">/mois</span>
              </div>
              <p className="text-slate-400 text-sm mt-2">Sans engagement</p>
            </div>
          </div>

          {/* Avantages */}
          <div className="grid md:grid-cols-2 gap-4 mb-8">
            <div className="flex items-center gap-3 bg-white/5 rounded-xl p-4">
              <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center">
                <Calendar className="text-amber-400" size={20} />
              </div>
              <div>
                <p className="text-white font-semibold">7j/7 - Week-ends inclus</p>
                <p className="text-slate-400 text-sm">Intervention même le dimanche</p>
              </div>
            </div>

            <div className="flex items-center gap-3 bg-white/5 rounded-xl p-4">
              <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center">
                <Star className="text-amber-400" size={20} />
              </div>
              <div>
                <p className="text-white font-semibold">Jours fériés inclus</p>
                <p className="text-slate-400 text-sm">Noël, 14 juillet, 1er mai...</p>
              </div>
            </div>

            <div className="flex items-center gap-3 bg-white/5 rounded-xl p-4">
              <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center">
                <Clock className="text-amber-400" size={20} />
              </div>
              <div>
                <p className="text-white font-semibold">Priorité d'intervention</p>
                <p className="text-slate-400 text-sm">Passage en priorité sur la liste</p>
              </div>
            </div>

            <div className="flex items-center gap-3 bg-white/5 rounded-xl p-4">
              <div className="w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center">
                <Shield className="text-amber-400" size={20} />
              </div>
              <div>
                <p className="text-white font-semibold">Débouchage garanti</p>
                <p className="text-slate-400 text-sm">Votre problème résolu rapidement</p>
              </div>
            </div>
          </div>

          {/* Liste des avantages */}
          <div className="bg-white/5 rounded-xl p-6 mb-8">
            <p className="text-amber-400 font-semibold mb-4 text-center">Vos avantages VIP :</p>
            <div className="grid sm:grid-cols-2 gap-3">
              {[
                "Intervention prioritaire 24h/24",
                "Week-ends et jours fériés inclus",
                "Aucune majoration tarifaire",
                "Ligne téléphonique dédiée",
                "Devis gratuit immédiat",
                "Technicien attitré"
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-2 text-slate-300">
                  <CheckCircle className="text-amber-400 flex-shrink-0" size={18} />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}>
              <Button className="bg-gradient-to-r from-amber-400 to-yellow-500 hover:from-amber-500 hover:to-yellow-600 text-slate-900 font-bold px-8 py-6 text-lg rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105">
                <Phone size={22} className="mr-2" />
                Devenir VIP : {companyInfo.phone}
              </Button>
            </a>
          </div>

          <p className="text-center text-slate-500 text-sm mt-6">
            * Offre réservée aux particuliers et professionnels de Cannes et alentours
          </p>
          <p className="text-center text-slate-500 text-xs mt-2">
            Abonnement sous condition d'une durée de souscription de 3 ans. Pour toute information, un conseiller est disponible.
          </p>
        </div>
      </div>
    </section>
  );
};

export default VipSubscription;
